"use client";

import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";

function RouteChangeLoader() {
  const router = useRouter();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleStart = () => setLoading(true);
    const handleComplete = () => setLoading(false);

    if (!router.events) return;

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleComplete);
    router.events.on("routeChangeError", handleComplete);

     
    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleComplete);
      router.events.off("routeChangeError", handleComplete);
    };
  }, [router]);

  if (!loading) return null;

  return (
    <>
      {/* Loading bar */}
      <div className="fixed inset-x-0 top-0 z-50 h-1 bg-gray-200/20">
        <div className="h-full animate-pulse bg-gradient-to-r from-purple-600 to-blue-600 shadow-lg">
          <div className="size-full animate-[loading_1s_ease-in-out_infinite] bg-gradient-to-r from-purple-600 to-blue-600 shadow-sm" />
        </div>
      </div>

      {/* Blocking overlay */}
      <div className="fixed inset-0 z-40 cursor-wait bg-transparent" onClick={e => e.stopPropagation()} />
    </>
  );
}

export default RouteChangeLoader;
